
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qms",
      function () {
        return require("private-next-pages/qms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qms"])
      });
    }
  